<fr-table #sqlTable [config]="tableConfig" [(data)]="sqlResultSetData" [safeMode]="true"
      [paginatorConfig]="paginatorConfig" Id="query-results-table">
      <div class="custom-table-title" table-title-text-space>
            <app-info-button [htmlText]="infoObject.results.htmlText" [title]="infoObject.results.infoTitle">
            </app-info-button>

      </div>
</fr-table>